import { useEffect, useState } from "react";
import { DrawerForm } from "../../../../../components/drawers/DrawerForm";
import { hasAccessToJobType, hasAccessToSource, useHub, useJobSources, useJobTypes } from "../../../../../core/Global";
import Job from "../../models/Job";
import TextBox from "../../../../../components/form/TextBox";
import DropDown from "../../../../../components/form/DropDown";
import { API_ROUTES } from "../../../../../core/Constants";
import TextArea from "../../../../../components/form/TextArea";
import Tagify from "../../../../../components/tagify/Tagify";

interface IProps {
    job?: Job
    onClose?: () => void
}
export default function JobDetailsEdit(props: IProps) {

    const hub = useHub()
    const jobTypes = useJobTypes().filter(t => hasAccessToJobType(t.id))
    const jobSources = useJobSources().filter(s => hasAccessToSource(s.id))

    const [job, jobSet] = useState<Job>();
    useEffect(() => jobSet(props.job), [props.job]);

    return (
        <>
            <DrawerForm id="drawer-edit-jobdetails"
                title="Edit Job Details"
                subtitle={"Job ID: " + job?.jobId + " | " + job?.fullName}
                buttonText="Update Job"
                onClose={props.onClose}
                onSubmit={(body, callback) => {

                    hub.Post(API_ROUTES.Jobs + "details", {
                        ...body,
                        id: props.job?.id
                    }, res => {
                        if (callback) callback(res);
                    })

                }}>

                <DropDown id="drp-edit-jobsources" name="jobSourceId" label="Job Source" labelUp marginBottom={5}
                    source={jobSources} parentModal="drawer-edit-jobdetails"
                    defaultValue={job?.jobSourceId} />

                <DropDown id="drp-edit-jobtypes" name="jobTypeId" label="Job Type" labelUp marginBottom={5}
                    source={jobTypes} parentModal="drawer-edit-jobdetails"
                    defaultValue={job?.jobTypeId} />

                <TextArea id="txt-edit-jobdetails" name="jobDetails" label="Job Details" labelUp marginBottom={5}
                    defaultValue={job?.jobDetails} rows={5} />

            </DrawerForm>
        </>
    )
}
